/* eslint-disable */
import React, { useEffect, useState } from 'react'
import Modal from 'react-modal';
import styled from 'styled-components';
import ButtonSecondary from 'components/ButtonSecondary';
import ButtonV2 from 'components/ButtonV2';
import {useHistory} from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';

// style
import './ConfirmModalSubmit.scss'

const Icon = styled.img``;
import Svg from "_assets/svg";
import Checkbox from 'components/Checkbox';
import CheckboxV2 from 'components/CheckboxV2';
import { Alert, AlertType } from 'utils/Alert';

// servicess
import waTemplateSvc from "services/waTemplateSvc";
import SuccessSubmitTemplate from './SuccessSubmitTemplate';
import { listLanguage} from 'containers/NewWaTemplate/ListDropdownData';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    // marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    background: '#FFFFFF',
    border: '1px solid #EBECF0',
    boxShadow: '1px 1px 20px rgba(170, 170, 170, 0.2)',
    borderRadius: '10px',
    width: '600px',
    padding: '25px'
  },
};

function ConfirmModalSubmit(props) {
  const {isOpenModal,setOpenModal} = props;
  const [isDataSummary, setDataSummary] = useState([])
  const [isLoading, setLoading] = useState(false)
  const [requestBody, setrequestBody] = useState([])
  const [isSuccessData, setSuccessData] = useState([])
  const [checked, setChecked] = useState([]);
  const history = useHistory();
  const [choosen,setChoosen]=useState([]);
  const [isDisableButton, setDisableButton] = useState(true)
  // console.log('isDataPayload',isDisableButton, isOpenModal.payload)

  useEffect(()=>{
    listLanguage.forEach((langData) => {
      isOpenModal.payload.forEach((item) =>{
        if(langData.value === item.language){
          item.dataLanguage = langData.name;
        }
      })
    })

    isOpenModal.payload.forEach((item) =>{
      if(item.components.length>0){
        item.bodyChecked = false;
        item.buttonsChecked = true;
        item.headerChecked = true;
        item.checked = false;
        setDisableButton(true)

        item.components.forEach((value) =>{
          const notAllowedStatus = [undefined, null, '', 'undefined', 'null']

          if(value.type === 'HEADER' && value.format === 'TEXT'){
            item.headerChecked = !notAllowedStatus.includes(value.text) ? true : false
            item.checked = !notAllowedStatus.includes(value.text) ? true : false
          }

          if(value.type === 'BODY'){
            item.bodyChecked = !notAllowedStatus.includes(value.text) ? true : false
            setDisableButton(!notAllowedStatus.includes(value.text) ? true : false)
            item.checked = !notAllowedStatus.includes(value.text) ? true : false
            // console.log('isDataPay', !notAllowedStatus.includes(value.text) ? true : false)
          }

          if(value?.type ===  'BUTTONS'){
            item.buttonsChecked = false;

            value?.buttons?.forEach((button) => {
              if(button.type === 'QUICK_REPLY'){
              item.buttonsChecked = !notAllowedStatus.includes(button.text) ? true : false;
              }

              if(button.type === 'PHONE_NUMBER'){
              item.buttonsChecked = !notAllowedStatus.includes(button.text) && !notAllowedStatus.includes(button.phone_number) ? true : false;
              }

              if(button.type === 'URL'){
              item.buttonsChecked = !notAllowedStatus.includes(button.text) && !notAllowedStatus.includes(button.url) ? true : false;
              }
            })
          }

          directFunctionValidation(item.headerChecked, item.bodyChecked, item.buttonsChecked)
        })
      }else{
        item.bodyChecked = false;
        item.buttonsChecked = true;
        item.headerChecked = true;
        item.checked = false;
        setDisableButton(true)
      }
 
    })

    // isOpenModal.payload.forEach((item) =>{
    //   item.components.forEach((value) =>{
    //     if(value.type === 'BODY'){
    //       if(value.text !== ''){
    //         item.checked = true;
    //         item.successValidate = true;
    //       }else{
    //         item.checked = false;
    //         item.successValidate = false;
    //       }
    //     }
    //   })
    // })
    setDataSummary(isOpenModal.payload)
    // setrequestBody(isOpenModal.payload)
  }, [isOpenModal.payload])

  // console.log('setDisableButton', isDisableButton)

  const [isValidationSchema, setValidationSchema] = useState()
  const directFunctionValidation = (headerChecked, bodyChecked, buttonsChecked) => {
    setValidationSchema({header:headerChecked, body:bodyChecked, buttons:buttonsChecked})
    // console.log('validation', headerChecked, bodyChecked, buttonsChecked)
  }

  function closeModal() {
    setOpenModal({show:false, payload: []})
  }

  const handleCheck = (event, dataCheck, index) => {
    let updatedList = [...checked];
  
    if (event.target.checked) {
      // updatedList = [...checked, {type: type, name: item.name, value: item.value}];
      updatedList = [...checked,dataCheck];
      isDataSummary.forEach((item) =>{
        if(item.language === dataCheck.language){
          item.checked = true
          // item.bodyChecked = true; 
          // item.headerChecked = true; 
          // item.buttonsChecked = true
        }
      })
    } else {
      isDataSummary.forEach((item) =>{
        if(item.language === dataCheck.language){
          item.checked = false
          // item.bodyChecked = false; 
          // item.headerChecked = false; 
          // item.buttonsChecked = false
        }
      })
      updatedList.splice(checked.findIndex(d => d.language === event.target.value), 1);
    }
 
    // if(isOpenModal.isEdit){
    //   setrequestBody(dataCheck)
    // }else{
    //   setrequestBody(updatedList)
    // }
    setChecked(updatedList);
  };

  const defaultCheckboxValue = (name) => {
      // let val = {type: type, value: name}
      return isDataSummary.some(d => d.checked === name.checked)
  };

  const _onSubmit = async () =>{
    let datarequestBody=[]
    isDataSummary.forEach((item) => {
      // item.components.forEach((value) =>{
      //   if(value.type === 'HEADER' && value.text === ''){
      //     item.disable = true;
      //   }
      // })

      if(item.checked){
        const tempData = {
          category: item.category,
          components: item.components,
          language: item.language,
          name: item.name
        }
        datarequestBody.push(tempData)
        // if(isOpenModal.isEdit){
        //   setrequestBody(dataCheck)
        // }else{
        //   setrequestBody(updatedList)
        // }
      }
    }); 
    setrequestBody(datarequestBody)
    // console.log('datarequestBody', datarequestBody)
    createAndUpdate(datarequestBody)
  }

  function createAndUpdate(datarequestBody){
    // console.log('datarequestBody', datarequestBody);
    if(datarequestBody.length>0){
      // if(isOpenModal.isEdit){
      //   editTemplate(datarequestBody);
      // }else{
      //   createTemplate(datarequestBody);
      // }
    }
  }

  async function createTemplate(datarequestBody){
    // console.log('requestBody', requestBody)
    setLoading(true)
    try {
      let listData = await waTemplateSvc.createWhatsappTemplate(isOpenModal.wabaID,datarequestBody)
      
      setLoading(false)
      let dataTemp = []
      listData.data.forEach((item) =>{
        if(item.error_reason == ''){
          dataTemp.push(item)
        }
      })
      if(dataTemp.length > 0){
        Alert.showStatus(
          AlertType.SUCCESS,
          'Success!',
          'Message Template Submitted'
        )
      }
      setSuccessData({show: true, payload: dataTemp})
      closeModal();
      // console.log('listData',listData)
    } catch (error) {
      setLoading(false)
      Alert.showStatus(
        AlertType.ERROR,
        'Error',
        error?.message
      )
    }
  }

  async function editTemplate(datarequestBody){
    setLoading(true)
    let components = []
    datarequestBody[0]?.components.forEach((value) =>{
      components.push(value)
    })
  
    try {
      let listData = await waTemplateSvc.editWhatsappTemplate(isOpenModal.wabaID,isOpenModal.templateID, {components})
      Alert.showStatus(
        AlertType.SUCCESS,
        'Message Template Submitted',
        '1 content change was made. Any new or edited content will automatically submitted for review.'
      )
      setLoading(false)
      // let dataTemp = []
      // listData.data.forEach((item) =>{
      //   if(item.error_reason == 0){
      //     dataTemp.push(item)
      //   }
      // })
      history.push('/whatsapp-template')
      // setSuccessData({show: true, payload: dataTemp})
      setOpenModal({show:false, payload: []})
    } catch (error) {
      setrequestBody([])
      // console.log('errors',error.message, error.response)
      let messageError = '';
      if(error?.response?.data?.errors?.message){
        messageError = error?.response?.data?.errors?.message;
      }else{
        messageError = error?.message
      }
      setLoading(false)
      Alert.showStatus(
        AlertType.ERROR,
        'Error',
        messageError
      )
    }
  }

  // console.log('isValidationSchema', isValidationSchema)
  return (
    <div>
      <SuccessSubmitTemplate openSuccessSubmitModal={isSuccessData}  setOpenSuccessSubmitModal={setSuccessData}/>
      <Modal
        isOpen={isOpenModal.show}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className='mb-4'>
          <h4 className='fsize-16 fweight-600 cl-neutral400'>Confirm which languages you’re submitting</h4>
          <p className='fsize-14 fweight-400 cl-neutral400'>If you choose not to submit a completed language now, it will not be saved and you’ll lose the</p>
        </div>
        <div className="wrapperr_body">
          {isDataSummary && isDataSummary.map((item, index) => {
            // console.log('return', !item?.bodyChecked && !item?.headerChecked && !item?.buttonsChecked)
            return (
            <div key={index} className='content d-flex align-items-center justify-content-between'>
              <div>
                <h4 className='fsize-14 fweight-600 cl-neutral400'>{item.dataLanguage}</h4>
                {
                  item?.bodyChecked && item?.headerChecked && item?.buttonsChecked
                  ?
                  <div className='fsize-12 fweight-400 cl-grey d-flex align-items-center'>
                    <span>Required fields complete</span>
                    <Icon src={Svg.check_success.default} alt="check_success" className='ms-2' />
                  </div>
                  :
                  <div className='wrapp_not_started fsize-12 fweight-400 cl-grey d-flex align-items-center'>
                    <span>Not started</span>
                    <FeatherIcon icon="x" className='ms-2' />
                  </div>
                }
              </div>
              <div>
              <CheckboxV2
                // className={`custom_`}
                className={`${!item?.bodyChecked || !item?.headerChecked || !item?.buttonsChecked ?
                'event_disable' : ''} custom_`}
                handleCheck={(event)=>handleCheck(event,item, index)}
                checked={item.checked}
                defaultChecked={defaultCheckboxValue(item)}
                value={item.language}
                name={item.language}
                id={item.language}
                data={item}
              />
              </div>
            </div>
            )})}
          <div className='d-flex align-items-center justify-content-end pt-5 mt-5'>
            <ButtonSecondary
              className=""
              handleRoute={closeModal}
              backgroundColor="#FFFFFF"
              textColor="#42526E"
              padding=".360rem 1rem"
            >Cancel</ButtonSecondary>
            <ButtonV2
              loading={isLoading}
              className={`${
                !isValidationSchema?.header || 
                !isValidationSchema?.body || 
                !isValidationSchema?.buttons || 
                isLoading ? 'event_disable' : ''} ms-4`}
              handleRoute={()=>_onSubmit()}
              disabled
              backgroundColor="#3B3B47"
              textColor="#FFFFFF"
              padding=".360rem 1rem"
            >
              {isLoading ? 'Please wait' : 'Confirm'}
            </ButtonV2>
          </div>
        </div>      
      </Modal>
    </div>
  )
}

export default ConfirmModalSubmit